<template>
	<div class="registorpage">
		<div class="login-header">
			<el-select  class="toggle" size="mini" @change="switchLangq(value)" v-model="value" placeholder="Language">
			    <el-option
			      v-for="item in options"
			      :key="item.value"
			      :label="item.label"
			      :value="item.value">
			    </el-option>
			 </el-select>
		</div>
		<div class="ttp">
			
			<!-- 注册中心 -->
			<div class="login-box" >
				<div class="login-box-header">
					<h2 style="color: #FFFFFF;">{{$t('registor.center')}}</h2>
				</div>
				<div class="login-main">
					<div style="font-size: 14px;width: 100%;">
						<span style="margin-left: 70px;font-size: 14px">{{$t('other.a530')}}<i style="color: red;font-size: 12px;">{{$t('other.a531')}}</i>：</span>
						 <el-select style="width: 120px;" v-model="countryvalue" :placeholder="$t('other.a50')">
						    <el-option
						      v-for="item in country"
						      :key="item.value"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
						  </el-select>
					</div>
					<span style="border-bottom: 1px #eee solid;">
						<label style="display:inline-block;width:100px;text-align:right">{{$t('other.a520')}}：</label>
						<el-input  class="input-text" v-model="registor_inputCountID" :placeholder="$t('registor.mail')"></el-input>
					</span>
					<span style="border-bottom: 1px #eee solid;">
						<label style="display:inline-block;width:100px;text-align:right">{{$t('other.a426')}}</label>
						<el-input class="input-text"  type="password" v-model="registor_password" :placeholder="$t('registor.passsword')"></el-input>
					</span>
					<span style="border-bottom: 1px #eee solid;">
						<label style="display:inline-block;width:100px;text-align:right">{{$t('other.a431')}}：</label>
						<el-input class="input-text" type="password"   v-model="registo_comfirPws" :placeholder="$t('registor.confirm_pws')"></el-input>
					</span>
					<span style="border-bottom: 1px #eee solid;">
						<label style="display:inline-block;width:100px;text-align:right">{{$t('other.a465')}}：</label>
						<el-input class="input-text" v-model="registor_inputusername" :placeholder="$t('registor.nickname')"></el-input>
					</span>
					<span style="border-bottom: 1px #eee solid;">
						<label style="display:inline-block;width:100px;text-align:right">{{$t('other.a532')}}：</label>
						<el-input class="input-text" v-model="storeAccount" :placeholder="$t('other.a536')"></el-input>
					</span>
					<span style="border-bottom: 1px #eee solid;">
						<label style="display:inline-block;width:100px;text-align:right">{{$t('other.a533')}}：</label>
						<el-input class="input-text" v-model="storeName" :placeholder="$t('other.a537')"></el-input>
					</span>
					<span style="border-bottom: 1px #eee solid;">
						<label style="display:inline-block;width:100px;text-align:right">{{$t('other.a534')}}：</label>
						<el-input class="input-text"  type="password" v-model="storeNamePws" :placeholder="$t('other.a538')"></el-input>
					</span>
					
					<span style="border-bottom: 1px #eee solid;">
						<label style="display:inline-block;width:100px;text-align:right">{{$t('other.a521')}}：</label>
						<el-input class="input-text"    v-model="phone" :placeholder="$t('registor.phone')"></el-input>	
					</span>
					<span style="border-bottom: 1px #eee solid;">
						<label style="display:inline-block;width:100px;text-align:right">{{$t('other.a434')}}：</label>
						<el-input class="input-text"    v-model="invitationCode" :placeholder="$t('other.a434')"></el-input>	
					</span>
					<span style="border-bottom: 1px #eee solid;">
						<label style="display:inline-block;width:100px;text-align:right">{{$t('other.a535')}}：</label>
						<el-input class="input-text"    v-model="emailCode" :placeholder="$t('registor.verification')"></el-input>	
					</span>
					
					<div style="width: 300px;text-align: right;font-size: 14px;cursor: pointer;margin: 10px 0;" @click="getemailCode">{{$t('registor.getCode')}}</div>
					<el-button class="input-text" type="primary" @click="registoer">{{$t('registor.register')}}</el-button>
					<div class="tologin" @click="gotoLogin">{{$t('registor.log')}}</div>
				</div>
			</div>
			
			
		</div>
		
		
	</div>
</template>

<script >
	import md5 from 'js-md5';
	import {mapState, mapActions , mapMutations} from 'vuex'
	export default{
		data() {
			return{
				emailCode:null,
				registor_inputCountID:'',
				countryvalue:'CN',
				country: [{
					  value: 'CN',
					  label: 'China'
					},{
					  value: 'TH',
					  label: 'Thailand'
				 },{
					  value: 'PH',
					  label: 'Philippines'
				 },{
					  value: 'ID',
					  label: 'Indonesia'
				 },{
					  value: 'TW',
					  label: 'Taiwan'
				 },{
					  value: 'SG',
					  label: 'Singapore'
				 },{
					  value: 'BZ',
					  label: 'Brazil'
				 },{
					  value: 'MY',
					  label: 'Malaysia'
				 },{
					  value: 'VN',
					  label: 'Vietnam'
				 }],
				registor_inputusername:'',
				registor_password:'',
				registo_comfirPws:'',
				inputCount: '' ,
				storeAccount:'',
				inputPassword:'',
				invitationCode:'',
				start_time:'',
				end_time:'',
				options: [{
				          value: 'zh',
				          label: '中文'
				        }, {
				          value: 'en',
				          label: 'English'
				 }],
				 value: '',
				 checked:false,
				 islogin:true,
				 phone:'',
				 storeName:'',
				 storeNamePws:'',
			}
		},
		computed:{
			...mapState({
				userInfo:state =>state.login.userInfo,
				loginStatus:state =>state.login.loginStatus,
				hasLogin:state =>state.login.hasLogin,
				registorSuccess:state =>state.login.registorSuccess,
			})
		},
		watch:{
			hasLogin(){
				setInterval(() =>{
					this.gotoindex()
				},500)
				
			},
			registorSuccess(){
				if(this.registorSuccess) {
					setInterval(() =>{
						this.$router.push('/login')
						this.SET_REGISTOR_FALSE()
					},1000)
				}
			}
			
		},
		
		created(){
			this.init()
		},
		mounted(){
		    //绑定事件
		     window.addEventListener('keydown',this.keyDown);
		  },
		destroyed(){
			  window.removeEventListener('keydown',this.keyDown,false);
		},
		  
	
		methods:{
			...mapActions('login',[
				'getEmailCode',
				'registerByIdonsia'
			]),
			
			...mapMutations('login', [
				'SWITCH_LANG',
				'SET_REGISTOR_FALSE'
			]),
			
			
			
			getemailCode(){
				// let passwordreg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,16}/
				// if(!passwordreg.test(this.registor_password)) {
				// 	this.$message.error("密码须由8位字母（abc），数字(0-9)，字符(!@#)组合而成！")
				// 		return
				// }
				if(!this.registor_inputCountID) {
					this.$message.error(this.$t('other.a523'))
					retur
				}else{
					
					
					const params={
						email:this.registor_inputCountID
					}
					this.getEmailCode(params)
				}
				
			},
			registoer(){
				// let passwordreg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,16}/
				// let mailCountreg=/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,4}$/;
				// if(!mailCountreg.test(this.registor_inputCountID)) {
				// 	this.$message.error(this.$t('other.a524'))
				// 		return
				// }
				// if(!passwordreg.test(this.registor_password)) {
				// 	this.$message.error("密码须由8位字母，数字，字符组合而成！")
				// 		return
				// }
				if(!this.emailCode && !this.registor_inputusername && !this.registo_comfirPws) {
					this.$message.error(this.$t('other.a525'))
					return
				}
				if(this.registor_password !== this.registo_comfirPws) {
					this.$message.error(this.$t('other.a526'))
					return
				}
				if(!this.phone) {
					this.$message.error(this.$t('other.a527'))
					return
				}
				if(!this.emailCode) {
					this.$message.error(this.$t('other.a528'))
					return
				}
				if(!this.registor_inputCountID || !this.registor_inputusername) {
					this.$message.error(this.$t('other.a529'))
					return
				}
				const params={
					country:this.countryvalue,
					isCloudStore:0,
					emailCode:parseInt(this.emailCode),
					password:md5(this.registor_password.replace(/\s+/g,"") + 'seller'),
					storeName:this.storeName,
					storeAccount:this.storeAccount,
					storePassword:md5(this.storeNamePws.replace(/\s+/g,"") +  'seller'),
					user:{
						userEmail:this.registor_inputCountID.replace(/\s+/g,""),
						userName:this.registor_inputusername.replace(/\s+/g,""),
						userPos:'SELLER',
						invitationCode:this.invitationCode,
						userPhone:this.phone.replace(/\s+/g,""),
						country:this.countryvalue,
						vipLevel:this.countryvalue == 'ID' ? 5 : 0
					}
				}
				console.log(params)
				this.registerByIdonsia(params)
			},
			init(){
				let account=JSON.parse(localStorage.getItem('userCount'))
				if(account){
					this.checked=true
					this.inputCount=account.account
					this.inputPassword=account.passsword
				}else{
					this.checked=false
				}
			},
			keyDown(e){
				if(e.keyCode === 13) {
					this.getLogin()
					
				}
			},
			switchLangq(value){
				this.SWITCH_LANG(value)
				this.$i18n.locale =  value 
				
			},
			gotoLogin(){
				this.$router.push('/loginPage')
			},
			
		
		}
	}
</script>

<style scoped>

	
	.registorpage{
			position: relative;
			width: 100%;
			height: 100vh;
			background-color: #fff;
			position: relative;
			/* background-image: url(../assets/img/loginbackground.png); */
			background-repeat:no-repeat; 
			background-size: cover;
			-webkit-background-size: cover;
			-o-background-size: cover;
			background-position: center 0;
			z-index: 2000;
			
	
		}
		
		.tologin{
			margin-bottom: 30px;
			cursor: pointer;
		}
		
		.login-box{
			
			   
			  
			  width: 438px;
			  border-radius: 10px;
			  background: #fff;
			  box-shadow: 0 0 25px #cac6c6;
	
		}
		.login-desc{
	
			width: 600px;
			height: 480px;
			background-color: #333536;
			opacity: 0.8;
			color: #fff;
			border-radius: 10px;
			box-sizing: border-box;
			padding: 20px 20px;
			z-index: -1;
		}
		.login-left,.login-right{
			width: 50%;
		}
		.pic-box{
			display: inline-block;
			width:155px;
			height: 155px;
		}
		
		.ppt{
			display: flex;
			justify-content:space-between;
			margin: 40px 0;
			
		}
		
		.login-title{
		
			font-size: 20px;
			font-weight: bold;
		}
		
		.input-text{
		
			width: 300px;
			margin: 10px 0;
			border: none;
		}
		
		.login-left,.login-right{
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}
	
		.registor{
			width: 80%;
			text-align: right;
			cursor: pointer;
		}
		.login-header{
			width: 100%;
			display: flex;
			justify-content: flex-end;
			margin: 20px 150px 0 0;
			
		}
		

		
		.login-box-header{
			height: 200px;
			background-image: url(../assets/img/login_01.png);
			background-repeat:no-repeat;
			background-size:100%;
			border-radius: 10px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}
		.login-main{
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}
		
		.input-btn{
			width: 200px;
			border-radius: 30px;
			margin: 50px;
		}
		
		.login-item{
			display: inline-block;
			margin: 10px 0;
			font-size: 18px;
			font-weight: bold;
			color: #FFFFFF;
		}
		
		.login-desc-item{
			font-weight: bold;
			line-height: 50px;
			margin-bottom: 20px;
		}
		
		.registorpage .ttp{
			width: 100%;
			display: flex;
			justify-content: space-around;
			box-sizing: border-box;
			padding: 30px 0;
			
			
		}	
		.ppt-item{
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			width: 50px;
			height: 50px;
		}
	
		.registorpage .el-input__inner{
			width: 250px;
			border: none!important;
		}
		 .el-input--mini{
			width: 170px!important;
		}
		
		
</style>
